import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import SEOTemplate from '../components/SEOTemplate';
import StructuredData, { localBusinessData } from '../components/StructuredData';

const Contact = () => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('表單提交數據:', formData);
    // 在這裡實現表單提交邏輯，例如 API 調用
    // 模擬提交成功
    setSubmitted(true);
    setFormData({
      name: '',
      email: '',
      subject: '',
      message: ''
    });
    setTimeout(() => {
      setSubmitted(false);
    }, 5000);
  };

  return (
    <>
      <SEOTemplate pageType="contact" />
      <StructuredData type={localBusinessData.type} data={localBusinessData.data} />
      
      {/* 頁面標題 */}
      <section className="py-5 bg-light">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center text-dark">
              <h1 className="display-4 text-dark">聯絡我們</h1>
              <p className="lead text-dark">與我們聯繫，討論您的項目需求</p>
            </div>
          </div>
        </div>
      </section>

      {/* 聯絡資訊與地圖並排 */}
      <section className="py-5">
        <div className="container">
          <div className="row">
            {/* 聯絡資訊（左側） */}
            <div className="col-md-6 mb-4 mb-md-0">
              <div className="contact-info p-4 bg-white shadow h-100">
                <h3 className="mb-4 text-dark">聯絡資訊</h3>
                <ul className="list-unstyled text-dark">
                  <li className="mb-3 d-flex align-items-center">
                    <i className="fas fa-map-marker-alt mr-3 text-dark"></i>
                    <div className="text-dark">
                      <strong>地址：</strong><br />
                      南投縣南投市南新路341巷50號
                    </div>
                  </li>
                  <li className="mb-3 d-flex align-items-center">
                    <i className="fas fa-envelope mr-3 text-dark"></i>
                    <div className="text-dark">
                      <strong>電子郵件：</strong><br />
                      karashuang@caesartechstudio.com
                    </div>
                  </li>
                  <li className="mb-3 d-flex align-items-center">
                    <i className="far fa-clock mr-3 text-dark"></i>
                    <div className="text-dark">
                      <strong>營業時間：</strong><br />
                      週一至週五: 上午 9:00 - 下午 6:00<br />
                      週六、週日: 休息
                    </div>
                  </li>
                </ul>
              </div>
            </div>

            {/* Google 地圖（右側） */}
            <div className="col-md-6">
              <div className="map-container shadow h-100">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3649.316285555985!2d120.68248127537183!3d23.8504111796944!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3469412c230614e9%3A0x8f3db0b08017e2e9!2zNTQ15Y2X5oqV57ij5Y2X5oqV5biC5Y2X5paw6Lev6ZW35biC5q61NTDomZ8!5e0!3m2!1szh-TW!2stw!4v1719893459494!5m2!1szh-TW!2stw"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  title="Google Map"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ 部分 */}
      <section className="py-5 bg-light">
        <div className="container">
          <div className="section-title text-dark">
            <h2 className="text-dark">常見問題</h2>
            <p className="text-dark">以下是我們經常收到的問題與解答</p>
          </div>

          <div className="row">
            <div className="col-lg-6 mb-4">
              <div className="card h-100">
                <div className="card-body text-dark">
                  <h5 className="card-title text-dark">您提供哪些服務？</h5>
                  <p className="card-text text-dark">
                    我們提供全方位的數位服務，包括網站設計與開發、行動應用程式開發、數位行銷策略、用戶體驗設計和企業系統整合等。
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-6 mb-4">
              <div className="card h-100">
                <div className="card-body text-dark">
                  <h5 className="card-title text-dark">專案開發需要多長時間？</h5>
                  <p className="card-text text-dark">
                    專案時間依複雜度而異。小型網站可能需要2-4週，複雜的網頁應用或行動應用可能需要2-6個月。我們會在專案啟動前提供詳細的時間表。
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-6 mb-4">
              <div className="card h-100">
                <div className="card-body text-dark">
                  <h5 className="card-title text-dark">貴公司如何確保專案品質？</h5>
                  <p className="card-text text-dark">
                    我們遵循嚴格的開發流程，包括需求分析、設計、開發、測試和部署。我們進行持續的代碼審查和自動化測試，確保最終產品符合最高標準。
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-6 mb-4">
              <div className="card h-100">
                <div className="card-body text-dark">
                  <h5 className="card-title text-dark">專案完成後是否提供支援服務？</h5>
                  <p className="card-text text-dark">
                    是的，我們提供專案完成後的支援服務，包括系統維護、錯誤修復和功能升級。我們也提供客戶培訓，確保您能夠順利操作和管理系統。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact; 